// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatISO/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatISOWithOptions = convertToFP(fn, 2);
export default formatISOWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatISOWithOptions/index.js
// module id = 881
// module chunks = 0